import * as React from 'react';
import FormControlContext from './FormControlContext';
export default function useFormControl() {
  return React.useContext(FormControlContext);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/FormControl/useFormControl.js
// module id = 2845
// module chunks = 0